<template>
    <div class="bonusomat-spin-winner">
        <WebpImage class="bonusomat-spin-winner__image" :src="winnerImage" alt="symbol výhry - pytel s penězi" />
        <div class="bonusomat-spin-winner__note" v-show="winnerNote" v-html="winnerNote"></div>
        <h3 class="bonusomat-spin-winner__text" v-html="winnerText"></h3>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { bonImgUrl } from "../../../utils/image-src";
import { SpinAutomatState } from "../../../models/bonusomat-spin-types";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import { DateTimeUtils } from "@sazka/utils/date-time-utils";

const props = defineProps<{
    state: SpinAutomatState;
    prizeText: string | undefined;
}>();

const winnerImage = computed(() => bonImgUrl("sack-with-money", "png"));

const winnerNote = computed(() => (props.state === "DISABLED" ? "Další zatočení za" : ""));

const winnerText = computed(() => {
    if (props.state === "DISABLED") {
        const midnight = new Date();
        midnight.setHours(24);
        midnight.setMinutes(0);
        midnight.setSeconds(0);
        midnight.setMilliseconds(0);

        const duration = DateTimeUtils.getDuration(midnight.getTime() - Date.now());

        return `<strong>${duration.h} ${DateTimeUtils.formatAfterXHoursLabel(duration.h)} a ${
            duration.m
        } ${DateTimeUtils.formatAfterXMinutesLabel(duration.m)}</strong>`;
    }

    if (props.state === "WINNING" && props.prizeText) {
        return props.prizeText;
    }

    return "<strong>Zde se zobrazí<br> vaše výhra<strong>";
});
</script>
